import React from 'react';
import PropTypes from 'prop-types';

import List from 'components/molecules/List/List';

/**
 * Custom unordered list based on List component
 * @param {*} props
 */
export default function UnorderedList(props) {
  const { items } = props;

  return <List type="ul">{items}</List>;
}

UnorderedList.propTypes = {
  /**
   * Array of text values.
   */
  items: PropTypes.array,
};
